import * as constants from './actions';

const initialState = {};

export default function recordVideoReducer(state = initialState, { type, payload }) {
    switch (type) {
        case constants.SAVED_FIRST_VIDEO:
            return {
                ...state,
                savedFirstVideo: true
            };
        case constants.RECORD_VIDEO_NO_EMAIL_SUCCESS:
            return {
                ...state,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
            };
        case constants.RECORD_VIDEO_SEND_EMAIL_SUCCESS:
            return {
                ...state,
                completeEmail: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                recipientMask: payload.recipientMask
            };
        case constants.STORE_VIDEO:
            return {
                ...state,
                videoURL: payload.videoURL,
                thumbnailURL: payload.thumbnailURL,
                fullVideoURL: payload.fullVideoURL,
                answerId: payload.answerId
            };
        case constants.IS_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.IS_BACK_TRANSITION:
            return {
                ...state,
                isBackTransition: payload
            };
        default:
            return state;
    }
}
